/**
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/16
 * Time: 10:50
 */

/** 数据设置错误 */

export const ErrCode = {
  ERR_RET0_SUCCESS: 0,
  ERR_RET1_SUCCESS: 1,
  ERR_FUN_RET_SUCCESS: 0,

  ERR_HTTP_STATUS_OK: 200, // HTTP STATUS成功状态

  ERR_HTTP_STATUS_AUTH_FAILED: 401, // HTTP STATUS=401,用户授权失败
  ERR_HTTP_STATUS_NOT_FOUND: 404, // HTTP STATUS=404,找不到API接口
  ERR_HTTP_STATUS_NOT_ACCEPT: 406, // HTTP STATUS=406,接口调用失败
  ERR_HTTP_STATUS_NOT_LOGIN: 407, // HTTP STATUS=407,用户未登陆

  ERR_HTTP_SERVER_ERROR: 500, // HTTP STATUS=500 服务错误

  /* 成功 */
  ERR_QS_API_SUCCESS: 20000, // 青鸽产品API返回成功

  /* 数据错误 */
  ERR_DATA_SET_ERROR: 10001, // 数据设置错误
  ERR_DATA_TOKEN_NOT_VALID: 10002, // TOKEN设置错误
  ERR_DATA_OBJECT_NOT_EXIST: 10003, // 数据对象错误(null,undefined)
  ERR_POST_TOKEN_INVALID: 10004, // 请求TOKEN失败
  ERR_PARAMS_SET_ERROR: 10005, // 参数设置错误
  ERR_DATA_CHECK_ERROR: 10006, // 数据检查失败
  ERR_TOKEN_NOT_FOUND: 10007, // 找不到Token
  ERR_SMS_LOGIN_TOKEN_INVALID: 10008, // 短信登录TOKEN错误

  ERR_DINGDING_JSSDK_ERROR: 11000, // dingding JSSDK API 错误

  ERR_GROUP_SITE_NOT_FOUND: 11001, // Group/Site找不到

  /* 事件数据错误 */
  ERR_EVENT_BODY_ERROR: 12000, // EVENT事件数据体格式错误

  /* API错误 */
  ERR_API_DATA_SUBMIT_ERROR: 30001, // 提交的数据有误

  /* 应用错误 */
  ERR_APP_OBJECT_NOT_EXIST: 40001, // 对象设置
  ERR_APP_CORPID_NOT_FOUND: 40002, // 无法找到corpId
  ERR_DB_OBJECT_NOT_EXIST: 40003, // 无法找到数据库对象

  ERR_APP_PLATFORM_ERROR: 40003, // 登录平台错误
  ERR_APP_SCAN_ERROR: 40005, // 扫码错误

  ERR_DATA_REGISTER_ERROR: 41001, // 手机号已经注册
  ERR_DATA_SUBMIT_LIMIT_ERROR: 41002, // 数据提交太频繁

  ERR_WX_QRCODE_SCAN_EXPIRED: 42001, // 微信登录二维码过期
  ERR_WX_QRCODE_SCAN_FAILED: 42002, // 微信扫码登录错误

  /* HTTP调用错误 */
  ERR_HTTP_REQUEST_ERROR: 40001, // HTTP请求错误

  ERR_USER_TOKEN_ERROR: 46407, // 用户登录Token无效 (EPSAPI返回)

  /* HTTP=>API状态错误定义 */
  ERR_API_HTTP_BASE_ERROR: 50000, // 基本的错误
  ERR_API_HTTP_SERVER_ERROR: 50500, // 服务器错误
  ERR_API_HTTP_NOT_FOUND: 50404, // 找不到资源

  ERR_TEMPLATE_FILE_NOT_FOUND: 51001, // 模板文件不存在
  ERR_WEIXIN_NOT_SUPPPORT: 51002, // 不支持微信服务

  ERR_SERVICE_ERROR: 80001, // 服务调用出错

  ERR_TOKEN_EXPIRED: 46408, // EMP-TOKEN 过期

  ERR_TOKEN_INVALID: 46409, // EMP-TOKEN 无效

  ERR_TOKEN_FAILED: 31004, // token出错

  NEW_EMP_ERR_TOKEN_EXPIRED: 512021, // 新emp的token过期
};
